import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {
    reservations: true,
    subscriptions: true,
  },
  production: false,
  staging: true,
  development: false,
  api: 'https://pauly-staging.azurewebsites.net',
  facebookAppId: '',
  instrumentationKey: '0d96412a-cabb-4738-80bd-d3196061409c',
  recaptchaSiteKey: '6LfVh_gtAAAAAHpRG5Ek10e0fB-AF7DqxsBFkiVQ',
  clarityId: '',
};
